import React from "react";
import Model from "./Model";
import tw from "tailwind-styled-components";
import { SideCancelBtn, SubmitBtn } from "./Styles/InputStyles";
import { useDispatch } from "react-redux";
import { Remove_User } from "../Redux/actions";
import { useNavigate } from "react-router-dom";

const Logout = ({ setIsLogout }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const handleLogout = () => {
        setIsLogout(false);
        dispatch(Remove_User());
        navigate("/login");
    };

    return (
        <Model
            width="w-full max-w-md"
            setOpenModel={setIsLogout}
            title="Logout Confirmation"
        >
            <WarningText>
                Are you sure you want to log out? You will need to sign in again to
                access your account and continue your session.
            </WarningText>

            <div className="w-full flex justify-between space-x-6 my-4">
                <SideCancelBtn type="button" onClick={() => setIsLogout(false)}>
                    Cancel
                </SideCancelBtn>
                <button
                    onClick={handleLogout}
                    className="rounded-md shadow-md  border border-rose-600 bg-white text-rose-600 hover:bg-rose-600 hover:text-white text-sm w-32  md:w-44 h-12 grid place-items-center disabled:opacity-50 disabled:cursor-not-allowed  md:text-base"
                >
                    Logout
                </button>
            </div>
        </Model>
    );
};

const WarningText = tw.p`text-gray-500 text-base mb-4`;

export default Logout;
